import React from 'react';
import HighchartsReact from 'highcharts-react-official';

/**
 * @typedef {Object} ChartData
 * @property {string} hours_of_day
 * @property {number} calls
 * @property {number} leads
 * @property {number} chats
 * @property {number} texts
 *
 * @param {{ chartData: ChartData[]}} props
 */
export default function TrafficByHour({ chartData }) {
  // Create an array to hold the formatted data
  const formattedData = new Array(24).fill({
    calls: 0,
    leads: 0,
    chats: 0,
    texts: 0,
  });

  // Fill the formatted data with actual values from the original data
  chartData.forEach((item) => {
    const index = parseInt(item.hours_of_day);
    formattedData[index] = {
      calls: item.calls,
      leads: item.leads,
      chats: item.chats,
      texts: item.texts,
    };
  });

  // Prepare the series data for Highcharts
  const seriesData = [
    {
      name: 'Calls',
      data: formattedData.map((item) => item.calls),
      color: '#106DB6',
    },
    {
      name: 'Chats',
      data: formattedData.map((item) => item.chats),
      color: '#9B7BB7',
    },
    {
      name: 'Texts',
      data: formattedData.map((item) => item.texts),
      color: '#607D8B',
    },
    {
      name: 'WebForms',
      data: formattedData.map((item) => item.leads),
      color: '#009999',
    },
  ];

  const chartOptions = {
    exporting: { enabled: false },
    credits: { enabled: false },
    chart: {
      type: 'column',
      marginBottom: 70,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [
        '12AM',
        '1AM',
        '2AM',
        '3AM',
        '4AM',
        '5AM',
        '6AM',
        '7AM',
        '8AM',
        '9AM',
        '10AM',
        '11AM',
        '12PM',
        '1PM',
        '2PM',
        '3PM',
        '4PM',
        '5PM',
        '6PM',
        '7PM',
        '8PM',
        '9PM',
        '10PM',
        '11PM',
      ],
    },
    legend: {
      floating: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      stackLabels: {
        enabled: true,
        formatter: function () {
          return this.total !== 0 ? this.total : '';
        },
      },
    },
    tooltip: {
      shared: false,
      headerFormat: '<b>{point.x}</b><br/>',
      pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          color: 'white',
          formatter: function () {
            return this.y !== 0 ? this.y : '';
          },
        },
      },
    },
    series: seriesData,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'top',
              layout: 'horizontal',
              itemMarginTop: 0,
              itemMarginBottom: 0,
              padding: 0,
            },
          },
        },
      ],
    },
  };

  return (
    <div className='row row_spacer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Traffic by Hour of the Day</div>
          <HighchartsReact highcharts={window.Highcharts} options={chartOptions} />
        </div>
      </div>
    </div>
  );
}
